// extracted by mini-css-extract-plugin
export default {"loginWrapper__checkboxLabel":"AdminLoginWrapper_loginWrapper__checkboxLabel__BfLao","loginWrapper__link":"AdminLoginWrapper_loginWrapper__link__lT8uV"};